export default __webpack_public_path__ + "static/media/check.ac3003df.svg";